module.exports = __webpack_public_path__ + "static/media/customers-empty.3c08b87a.svg";